export const HashAlgorithm = Object.freeze(
    {
        SHA3_256: 0,
        KECCAK_256: 1,
        RIPEMD_160: 2,
        SHA_256: 3
    }
) 
